import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Space, Tag, Tooltip, message } from 'antd';
import { TranslationOutlined, CopyOutlined } from '@ant-design/icons';
import { withLocale } from '../../l10n/index.jsx';
import DataTable from '../DataTable/DataTable.jsx';
import { GetColumnLiteralSearchProps } from '../../utils/functions.jsx';
import { getLanguageName } from '../../utils/l10n.constants.js';
import { useGetLibrariesQuery, useGetTemplatesQuery } from '../../services/translateApi.js';

function LibrariesList({ type = 'libraries', lang }) {

  // ===== 1. ESTADOS =====
  const navigate = useNavigate();
  const [selectedUuid, setSelectedUuid] = useState(null);

  // ===== 2. DATOS =====
  const librariesQuery = useGetLibrariesQuery(undefined, { skip: type !== 'libraries' });
  const templatesQuery = useGetTemplatesQuery(undefined, { skip: type !== 'templates' });
  const { data = [], isFetching } = type === 'templates' ? templatesQuery : librariesQuery;

  // ===== 3. HANDLERS =====
  const rowSelection = {
    onChange: (_keys, rows) => setSelectedUuid(rows[0]?.uuid ?? null),
  };

  const translateLibrary = () => {
    if (selectedUuid) navigate(`/translator/${selectedUuid}`);
  };

  const copyUuid = async (uuid) => {
    if (!uuid) return;
    try {
      await navigator.clipboard.writeText(uuid);
      message.success(lang.handle('UUID copiado al portapapeles'));
    } catch (err) {
      console.error('Error al copiar el UUID:', err);
      message.error(lang.handle('Error al copiar el UUID'));
    }
  };

  // ===== 8. CONFIG (columnas) =====
  const columns = [
    {
      title: lang.handle('Nombre'),
      dataIndex: 'name',
      width: '35%',
      sorter: (a, b) => String(a.name || '').localeCompare(String(b.name || '')),
      ...GetColumnLiteralSearchProps('name', lang)
    },
    {
      title: lang.handle('Descripción'),
      dataIndex: 'description',
      width: '45%',
      sorter: (a, b) => String(a.description || '').localeCompare(String(b.description || '')),
      ...GetColumnLiteralSearchProps('description', lang)
    },
    {
      title: lang.handle('Idioma por defecto'),
      dataIndex: ['l10n', 'default_lang'],
      width: '15%',
      render: (code) => (code ? <Tag>{lang.handle(getLanguageName(code))}</Tag> : '-'),
    },
    {
      key: 'actions',
      width: '5%',
      align: 'center',
      render: (_value, record) => (
        <Tooltip title={lang.handle('Copiar UUID')}>
          <Button
            type="text"
            shape="circle"
            icon={<CopyOutlined />}
            onClick={() => copyUuid(record.uuid)}
          />
        </Tooltip>
      ),
    },
  ];

  // ===== 9. RENDER =====
  return (
    <div>
      <DataTable
        rowSelection={{ type: 'radio', ...rowSelection }}
        columns={columns}
        rowKey="uuid"
        dataSource={data}
        loading={isFetching}
        scroll={null}
      />
      <div className="button-panel">
        <Space>
          <Button
            type="primary"
            icon={<TranslationOutlined />}
            disabled={!selectedUuid}
            onClick={translateLibrary}
          >
            {lang.handle('Traducir')}
          </Button>
        </Space>
      </div>
    </div>
  );
}

export default withLocale(LibrariesList);
